import { WarrantEntity } from '../../../../types/WarrantEntity'
import { IssueEntity } from '../../../../types/IssueEntity'
import { DropdownItem } from '../../../components/DropdownItem'
import { DropdownTreeViewItems } from '../DropdownTreeView'
import { getSectorIdFromIssueOrWarrant } from './sectors'
import { getSortLocale } from '../../../../i18n/localeUtils'
import { translateMillistreamSector } from '../../../../utils/millistreamSectors'

export const getAdvisors = (issues: IssueEntity[], language?: string) => {
    const sortLocale = getSortLocale(language)
    const advisorTypes = ['financialAdvisors', 'legalAdvisors'] as const
    const advisorsMap: { [key: string]: { [key: string]: DropdownItem & { hasNoName: boolean } } } = {
        financialAdvisors: {},
        legalAdvisors: {},
    }
    const issuesCount = {}

    issues.forEach((issue) => {
        if (issue.financialAdvisors?.length === 0 && issue.legalAdvisors?.length === 0) return

        advisorTypes.forEach((advisorType) => {
            ;(issue[advisorType] || []).forEach((advisor) => {
                if (!advisorsMap[advisorType][advisor.advisorId]) {
                    advisorsMap[advisorType][advisor.advisorId] = {
                        label: advisor.name || '',
                        hasNoName: !!advisor.name,
                        id: advisor.advisorId,
                    }
                    issuesCount[advisor.advisorId] = 0
                }

                issuesCount[advisor.advisorId]++
            })
        })
    })

    const othersThreshold = 3
    const advisors = advisorTypes.reduce((acc, advisorType) => {
        return {
            ...acc,
            [advisorType]: [
                ...Object.values(advisorsMap[advisorType]).filter(
                    (advisor) => issuesCount[advisor.id] >= othersThreshold,
                ),
                {
                    id: Object.values(advisorsMap[advisorType])
                        .filter(
                            (advisor) => issuesCount[advisor.id] < othersThreshold || issuesCount[advisor.id].hasNoName,
                        )
                        .map(({ id }) => id)
                        .join(','),
                    label: 'Övriga',
                },
            ].sort((a, b) => a.label.localeCompare(b.label, sortLocale)),
        }
    }, {}) as { [key in (typeof advisorTypes)[number]]: DropdownItem[] }

    return advisors
}

export const getSectors = (entities: IssueEntity[] | WarrantEntity[]) => {
    const sectors: DropdownTreeViewItems = {}

    entities.forEach((entity) => {
        if (entity.sectorLevel1 === null) return

        if (!sectors[entity.sectorLevel1]) {
            sectors[entity.sectorLevel1] = []
        }

        const id = getSectorIdFromIssueOrWarrant(entity)

        if (sectors[entity.sectorLevel1].find((level) => level.id === id)) return

        sectors[entity.sectorLevel1].push({
            id,
            label: translateMillistreamSector(2, entity.sectorLevel2),
        })
    })

    return sectors
}
